import { render } from "./TryChat.vue?vue&type=template&id=6f774c8e&scoped=true"
import script from "./TryChat.vue?vue&type=script&lang=js"
export * from "./TryChat.vue?vue&type=script&lang=js"

import "./TryChat.vue?vue&type=style&index=0&id=6f774c8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f774c8e"]])

export default __exports__